<div *ngIf="!isMobileUser" class="empty-page" id='404-page'>
	<div class="faded-grey" style="line-height: 15px;">404</div>
	<div>Page Not Found</div>
	<small> <a (click)="navigate()">{{buttonName}}</a> </small>
</div>
<div *ngIf="isMobileUser">
	<app-mobile-page-not-found
		[buttonName]="buttonName"
		[route]="previousRoute">
	</app-mobile-page-not-found>
</div>
